import {
  Accordion,
  ActionIcon,
  Badge,
  Box,
  Button,
  Checkbox,
  Drawer,
  Flex,
  Grid,
  Group,
  Modal,
  NumberInput,
  Radio,
  rem,
  Select,
  SimpleGrid,
  Switch,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import { AiOutlineDelete } from "react-icons/ai";
import { LuInfo } from "react-icons/lu";
import React, { useEffect, useRef, useState } from "react";
import {
  addPlan,
  editPlan,
  getAllPlans,
  getPlans,
  getPlanTypes,
} from "../../services/supportplan";
import useStyles from "./style";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { IconChevronDown, IconPlus } from "@tabler/icons-react";
import { DateInput, DatePickerInput } from "@mantine/dates";
import { IoCalendarClearOutline, IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { getAllFacilities } from "../../services";
import { planTypeLabels } from "./ClientSupportPlans";
import { FiEdit } from "react-icons/fi";
import { getNotes } from "../../services/note";
import moment from "moment";
import DiscontinueCarePlanModal from "./DiscontinueCarePlanModal";
import { decrypt } from "../../utils";
import EffectivePeriodDatePicker from "./EffectivePeriodDatePicker";
import { getAllPatientsModal } from "../../services/patient";
import ServiceAndReassessDatePicker from "./Service&ReassessDatePicker";
import { MdOutlineCalendarToday } from "react-icons/md";
import { isStaff } from "../../http";
import ServicePlanForm from "../ServicePlanComponents/ServicePlanForm";

function CarePlanDetailsDrawer({
  isOpen,
  view,
  edit,
  client,
  segment,
  setRowData,
  carePlanType,
  addPlanLoading,
  openAddMedicalModal,
  handleTableBoxClick,
  setShowCarePlanDetails,
  clientFacilities,
  rowData,
  currentPage,
  clientDetails,
}) {
  const icon = (
    <DropDownArrowSvg
      style={{ width: rem(1), height: rem(1) }}
      color={"#94A3B8"}
    />
  );
  const [state, setState] = useState({ startDate: null, endDate: null });
  const [showCustomOutcome, setShowCustomOutcome] = useState({});
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [selectedPlanType, setSelectedPlanType] = useState(null);
  const [openedAccordion, setOpenedAccordion] = useState(null);
  const [openedGoalAccordion, setOpenedGoalAccordion] = useState(null);
  const [openedEssentialAccordion, setOpenedEssentialAccordion] =
    useState(null);
  const [checkedSkillBuilding, setCheckedSkillBuilding] = useState([]);
  const [checkedIntensiveInHome, setCheckedIntensiveInHome] = useState([]);
  const [selected, setSelected] = useState(null);
  const [errors, setErrors] = useState({});
  const [types, setTypes] = useState([]);
  const { classes } = useStyles();
  const [essentialSupportAdded, setEssentialSupportAdded] = useState("no");
  const { allFacilities } = useSelector((state) => state?.facility);
  const { allPatients } = useSelector((state) => state?.patient);
  const selectedClient = allPatients?.find((val) => val?.id === client);
  const isMobileScreen = useMediaQuery("(max-width: 1048px)");
  const buttonRef = useRef();
  const labels = planTypeLabels[selectedPlanType] || planTypeLabels["1"];
  const [openedModal, setOpenedModal] = useState(null);
  const [discontinueType, setDiscontinueType] = useState();
  const [activityId, setActivtyId] = useState(null);
  const [outcomeId, setOutcomeId] = useState(null);
  const outcomeData = rowData?.outcomes;
  const [opened, { close, open }] = useDisclosure(false);
  const [dateRange, setDateRange] = useState({
    type: null,
    date: [],
  });
  const [selectedServiceAndReassessDates, setSelectedServiceAndReassessDates] =
    useState({});
  const { profile } = useSelector((state) => state?.profile);

  //  useEffect(() => {
  //     getAllPatientsModal("assign");
  //   }, []);

  // Initial structure for outcomes
  const initialOutcome = {
    outcomeCategory: "",
    outcomeTitle: "",
    customOutcome: "",
    outcomeDescription: "",
    additionalInformation: "",
    outcomeNumber: "",
    keySteps: [{ id: Date.now(), text: "" }],
    activities: [
      {
        id: Date.now(),
        activity: "",
        supportInstructions:
          selectedPlanType === 3 ? [{ id: Date.now(), text: "" }] : "",
        skillBuilding: "no",
        skillBuildingText: "",
        intensiveInHome: "no",
        activityNumber: "1a",
        whatToRecord: [{ id: Date.now(), text: "" }],
      },
    ],
    howOften: "",
    iNoLongerNeedThisOutcome: "",
  };

  // Initial structure for essential support
  const initialEssentialSupport = {
    essentialSupportType: "",
    essentialNumber: "",
    activityNumber: "1a",
    activities: [
      {
        id: Date.now(),
        howToSupport: [{ id: Date.now(), text: "" }],
        howOftenEssentialSupport: "",
        supportStatement: "",
        activity: "",
        activityNumber: "1a",
      },
    ],
  };

  // Initial structure for goals
  const initialGoals = {
    Identified_Relevant_Attainable_Goals: "",
    targetBehavior: "",
    goalNumber: "",
    goalActivities: [
      {
        id: Date.now(),
        objectives: "",
        Intervention_Instruction: "",
        objectiveNumber: "",
      },
    ],
    goalFrequency: "",
    goalDuration: "",
    goalTimeframe: "",
    goalNote: "",
  };

  const [outcome, setOutcome] = useState([
    { id: Date.now(), ...initialOutcome, outcomeNumber: 1 },
  ]);
  const [essentialSupport, setEssentialSupport] = useState([
    { id: Date.now(), ...initialEssentialSupport, essentialNumber: 1 },
  ]);
  const [goals, setGoals] = useState([
    { id: Date.now(), ...initialGoals, goalNumber: 1 },
  ]);

  const getData = async () => {
    let data = await getPlanTypes();
    setTypes(data);
  };

  useEffect(() => {
    getAllPatientsModal();
  }, []);

  useEffect(() => {
    if (!edit && !view) {
      setOutcome([{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }]);
    }
  }, [selectedPlanType]);

  useEffect(() => {
    getData();
    getAllFacilities("all");
  }, []);

  useEffect(() => {
    if (carePlanType) {
      setSelectedPlanType(
        carePlanType === "661510986a6068af0f4e06e6"
          ? 1
          : carePlanType === "67971b9c908d7890e5263bd9"
            ? 2
             : carePlanType === "697af3afc4a8059827425f67"  // Service Plan ID
        ? 5
            : carePlanType === "68ae9ad573178c6bd823ac2f"
              ? 4
              : 3,
      );
    }
  }, [carePlanType]);

  useEffect(() => {
    if (carePlanType) {
      // setSelectedPlanType(carePlanType);
      setSelected(carePlanType);
      setOpenedAccordion("0");
      setOpenedGoalAccordion("0");
      essentialSupport?.length > 0 &&
        setOpenedEssentialAccordion(essentialSupport[0]?.id?.toString());
    }
  }, [carePlanType]);

  useEffect(() => {
    if (rowData) {
      // let plan = types?.find(_t => _t?.id === rowData?.planType?._id)
      setSelected(rowData?.planType?._id);
      setSelectedPlanType(+rowData?.planType?.planId);
    }
  }, [rowData]);

  useEffect(() => {
    if ((edit || view) && types?.length > 0 && !selected) {
      setSelected(types?.[0]?.id);
    }
  }, [types]);

  useEffect(() => {
    if (outcome) {
      const initialChecked = outcome?.map((outcomeItems) =>
        outcomeItems?.activities?.map(
          (activity) => activity?.skillBuilding === "yes",
        ),
      )?.[0];
      setCheckedSkillBuilding(initialChecked || []);

      const initialCheckedIntensiveInHome = outcome?.map((outcomeItems) =>
        outcomeItems?.activities?.map(
          (activity) => activity?.intensiveInHome === "yes",
        ),
      )?.[0];
      setCheckedIntensiveInHome(initialCheckedIntensiveInHome || []);
    }
  }, [outcome]);

  useEffect(() => {
    if (view || edit) {
      let form = rowData?.outcomes?.length > 0 ? rowData?.outcomes : [];

      form = form.map((outcome) => {
        let activities =
          outcome?.activities?.length > 0
            ? outcome.activities.map((act) => ({
                ...act,
                supportInstructions:
                  typeof act?.supportInstructions === "string" &&
                  selectedPlanType === 3
                    ? [{ id: Date.now(), text: act.supportInstructions }]
                    : act.supportInstructions,
                whatToRecord:
                  typeof act?.whatToRecord === "string" &&
                  selectedPlanType === 3
                    ? [{ id: Date.now(), text: act.whatToRecord }]
                    : act.whatToRecord,
              }))
            : [
                {
                  id: Date.now(),
                  supportActivity: outcome?.supportActivity || "",
                  supportInstructions:
                    typeof outcome?.supportInstructions === "string" &&
                    selectedPlanType === 3
                      ? [{ id: Date.now(), text: outcome?.supportInstructions }]
                      : outcome?.supportInstructions,
                  activityNumber: `${outcome?.outcomeNumber}a`,
                  intensiveInHome: outcome?.intensiveInHome || "no",
                  skillBuilding: outcome?.skillBuilding || "no",
                  whatToRecord:
                    typeof outcome?.whatToRecord === "string" &&
                    selectedPlanType === 3
                      ? [{ id: Date.now(), text: outcome?.whatToRecord }]
                      : outcome?.whatToRecord,
                },
              ];

        return {
          ...outcome,
          byWhen: moment(outcome?.byWhen).toDate(),
          activities,
        };
      });

      setOutcome(form);
      setOpenedAccordion("0");
      setOpenedGoalAccordion("0");
      setSelectedFacility(rowData?.facility?._id);
      setState({
        startDate: rowData?.startDate ? new Date(rowData?.startDate) : null,
        endDate: rowData?.endDate ? new Date(rowData?.endDate) : null,
      });
    }
  }, [view, edit, selectedPlanType]);

  useEffect(() => {
    if (rowData?.goals && rowData?.goals.length > 0) {
      const formattedGoals = rowData.goals.map((goal, index) => ({
        ...goal,
        id: goal.id || Date.now() + index,
        goalActivities:
          goal.goalActivities && goal.goalActivities.length > 0
            ? goal.goalActivities.map((activity, actIndex) => ({
                ...activity,
                id: activity.id || Date.now() + actIndex + 1000,
              }))
            : [
                {
                  id: Date.now() + index + 2000,
                  objectives: "",
                  Intervention_Instruction: "",
                  objectiveNumber: `${goal?.goalNumber}a`,
                },
              ],
      }));
      setGoals(formattedGoals);
      setSelectedServiceAndReassessDates({
        service: {
          start: rowData?.startDate ? new Date(rowData?.startDate) : null,
          end: rowData?.endDate ? new Date(rowData?.endDate) : null,
        },
        reassess: rowData?.reassessDate?.map((item) => ({
          ...item,
          start: item.start ? new Date(item.start) : null,
          end: item.end ? new Date(item.end) : null,
          type:
            item.title === "30 Days"
              ? "30 Days"
              : item.title === "60 Days"
                ? "60 Days"
                : item.title === "90 Days"
                  ? "90 Days"
                  : "Custom",
        })),
      });
    }
  }, [view, edit]);

  useEffect(() => {
    if (rowData) {
      setEssentialSupportAdded(
        rowData?.essentialSupport?.length ? "yes" : "no",
      );
      if (rowData?.essentialSupport) {
        const formattedEssentialSupport = rowData.essentialSupport.map(
          (support) => ({
            ...support,
            effectivePeriods:
              support.effectivePeriods?.map((dateStr) => new Date(dateStr)) ||
              [],
            activities: support?.activities.map((act) => ({
              ...act,
              howToSupport:
                typeof act?.howToSupport === "string" && selectedPlanType === 3
                  ? [{ id: Date.now(), text: act.howToSupport }]
                  : act.howToSupport,
            })),
          }),
        );
        setEssentialSupport(formattedEssentialSupport);
        setOpenedEssentialAccordion(
          formattedEssentialSupport[0]?.id?.toString(),
        );
      }
    }
  }, [rowData, selectedPlanType]);

  const alphabet = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];

  // no record
  const NoRecord = () => {
    return (
      <div
        style={{
          height: "200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src="/assets/images/building.png"
          style={{
            height: "100px",
            width: "100px",
            objectFit: "contain",
          }}
          alt="no record found"
        />
        <Text style={{ opacity: 0.3 }} mt={10}>
          No Outcomes Found
        </Text>
      </div>
    );
  };

  // save
  const onSave = async (isNewSave = false, servicePlanData) => {
    try {
      if (!validateForm()) {
        // alert("Please fill in all the required fields");
        return;
      }
      if (edit) {
        let obj = {
          id: rowData?._id,
          facility: selectedFacility,
          planType: selected,
          startDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.service?.start
              : state.startDate,
          endDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.service?.end
              : state.endDate,
          reassessDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.reassess?.map(
                  ({ start, end, title }) => ({
                    start,
                    end,
                    title,
                  }),
                )
              : undefined,
          supportPlanName: rowData?.supportPlanName,
          // outcomes: outcome,
          outcomes:
            selectedPlanType === 4
              ? []
              : outcome?.map((item) => {
                  return {
                    ...item,
                    activities: item?.activities?.map((activity, index) => {
                      return {
                        ...activity,
                        activityNumber: `${item?.outcomeNumber}${alphabet[index]}`,
                        whatToRecord:
                          selectedPlanType === 3
                            ? activity?.whatToRecord
                            : undefined,
                      };
                    }),
                  };
                }),
          essentialSupport:
            essentialSupportAdded == "yes"
              ? essentialSupport?.map((item) => {
                  return {
                    ...item,
                    activities: item?.activities?.map((activity, index) => {
                      return {
                        ...activity,
                        activityNumber: `${item?.activityNumber}${alphabet[index]}`,
                      };
                    }),
                  };
                })
              : [],
          goals: goals?.map((item) => {
            return {
              ...item,
              goalActivities: item?.goalActivities?.map((activity, index) => {
                return {
                  ...activity,
                  objectiveNumber: `${item?.objectiveNumber}${alphabet[index]}`,
                };
              }),
            };
          }),
          isNewSave: isNewSave ? true : false,
          // ),
        };
        await editPlan(obj);
        setOutcome([{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }]);
        setGoals([{ id: Date.now(), ...initialGoals, goalNumber: 1 }]);
        setRowData(null);
        setShowCarePlanDetails(false);
        // getPlans(currentPage || 1, client?.planDoc ? rowData?.client?._id : client, segment);
        getPlans(currentPage || 1, client, segment);
        getAllPlans();
        getNotes(1, client, false);
        closeCarePlanModal();
      } else {
        let payload = {
          planType: selected,
          facility: selectedFacility,
          client: client,
          isActive: true,
          startDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.service?.start
              : new Date(),
          endDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.service?.end
              : state.endDate,
          reassessDate:
            selectedPlanType === 4
              ? selectedServiceAndReassessDates?.reassess?.map(
                  ({ start, end, title }) => ({
                    start,
                    end,
                    title,
                  }),
                )
              : undefined,
          outcomes:
            selectedPlanType === 4
              ? []
              : outcome?.map((item) => {
                  return {
                    ...item,
                    activities: item?.activities?.map((activity, index) => {
                      return {
                        ...activity,
                        activityNumber: `${item?.outcomeNumber}${alphabet[index]}`,
                        whatToRecord:
                          selectedPlanType === 3
                            ? activity?.whatToRecord
                            : undefined,
                      };
                    }),
                  };
                }),
          essentialSupport:
            essentialSupportAdded == "yes"
              ? essentialSupport?.map((item) => {
                  return {
                    ...item,
                    activities: item?.activities?.map((activity, index) => {
                      return {
                        ...activity,
                        activityNumber: activity?.activityNumber,
                      };
                    }),
                  };
                })
              : [],
          goals: goals?.map((item) => {
            return {
              ...item,
              goalActivities: item?.goalActivities?.map((activity, index) => {
                return {
                  ...activity,
                  objectiveNumber: `${item?.objectiveNumber}${alphabet[index]}`,
                };
              }),
            };
          }),
        };
        setState((p) => {
          return {
            ...p,
            ...payload,
          };
        });
        const response = await addPlan({
          ...state,
          ...payload,
        });
        if (response?.status === 200) {
          setSelectedFacility(null);
          setSelected(null);
          setSelectedPlanType(null);
          handleTableBoxClick();
          setGoals([{ id: Date.now(), ...initialGoals, goalNumber: 1 }]);
        }
        if (carePlanType) {
          openAddMedicalModal();
          closeCarePlanModal();
        } else {
          getPlans(1, client, segment?.toLowerCase());
          getAllPlans();

          // Reset the form and outcome state
          setOutcome([{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }]);
          setState({ startDate: null, endDate: null });
          setSelectedServiceAndReassessDates({});
          setSelected(null);
          setGoals([{ id: Date.now(), ...initialGoals, goalNumber: 1 }]);

          // Hide CarePlanDetails and show the table with pagination
          setShowCarePlanDetails(false);
          setRowData(null);
          closeCarePlanModal();
        }
      }
    } catch (error) {}
    // onSubmit(outcome);

    // setOutcome(initialOutcome);
  };

  // outcome hander function
  const handleOutcomeChange = (outcomeId, field, value) => {
    let current = outcome.find((v) => v?.id === outcomeId);
    setOutcome((prevOutcome) =>
      prevOutcome.map((outcome) =>
        outcome.id === outcomeId
          ? {
              ...outcome,
              [field]: value,
              isActive: true,
              // errors: {
              //   ...outcome.errors,
              //   [field]:
              //     current?.required?.includes(field) && value == ""
              //       ? "Required"
              //       : undefined
              // }
            }
          : outcome,
      ),
    );
  };

  // goals hander function
  const handleGoalsChange = (goalId, field, value) => {
    let current = goals.find((v) => v?.id === goalId);
    setGoals((prevGoals) =>
      prevGoals.map((goals) =>
        goals.id === goalId
          ? {
              ...goals,
              [field]: value,
              isActive: true,
              // errors: {
              //   ...goals.errors,
              //   [field]:
              //     current?.required?.includes(field) && value == ""
              //       ? "Required"
              //       : undefined
              // }
            }
          : goals,
      ),
    );
  };

  // essential support handler function
  const handleEssentialSupportChange = (supportId, field, value) => {
    setEssentialSupport((prev) =>
      prev.map((support) =>
        support.id === supportId ? { ...support, [field]: value } : support,
      ),
    );
  };

  // Add essential support activity
  const addEssentialActivity = (supportId, activityIndex) => {
    setEssentialSupport((prev) => {
      return prev.map((support, idex) =>
        support.id === supportId
          ? {
              ...support,
              activities: [
                ...support.activities,
                {
                  // ...initialEssentialSupport,
                  id: Date.now(),
                  activityNumber: `${idex + 1}${alphabet[activityIndex + 1]}`,
                  howToSupport: [{ id: Date.now(), text: "" }],
                },
              ],
            }
          : support,
      );
    });
  };

  // Remove essential support activity
  const removeEssentialActivity = (supportId, activityId) => {
    setEssentialSupport((prev) =>
      prev.map((support) =>
        support.id === supportId
          ? {
              ...support,
              activities: support.activities.filter(
                (act) => act.id !== activityId,
              ),
            }
          : support,
      ),
    );
  };

  // Handle essential activity change
  const handleEssentialActivityChange = (
    supportId,
    activityId,
    field,
    value,
  ) => {
    setEssentialSupport((prev) =>
      prev.map((support) =>
        support.id === supportId
          ? {
              ...support,
              activities: support.activities.map((act) =>
                act.id === activityId ? { ...act, [field]: value } : act,
              ),
            }
          : support,
      ),
    );
  };

  // outcome's activity handler function
  const handleactivityChange = (outcomeId, field, value, activityId) => {
    let tempOutcome = outcome;

    const tempResult = tempOutcome.map((outcome) =>
      outcome.id === outcomeId
        ? {
            ...outcome,
            activities: outcome?.activities?.map((activity) =>
              activity.id === activityId
                ? {
                    ...activity,
                    [field]: value,
                    isActive: true,
                  }
                : activity,
            ),
          }
        : outcome,
    );

    setOutcome(tempResult);
  };

  // goal's activity handler function
  const handleGoalActivityChange = (goalId, field, value, goalActivityId) => {
    let tempGoals = goals;

    const tempResult = tempGoals.map((goal) =>
      goal.id === goalId
        ? {
            ...goal,
            goalActivities: goal?.goalActivities?.map((goal) =>
              goal.id === goalActivityId
                ? {
                    ...goal,
                    [field]: value,
                    isActive: true,
                  }
                : goal,
            ),
          }
        : goal,
    );

    setGoals(tempResult);
  };

  // add new outcome
  const addOutcome = () => {
    if (edit) {
      setOutcome([
        ...outcome,
        {
          id: Date.now(),
          ...initialOutcome,
          outcomeNumber: outcome?.slice(-1)[0]?.outcomeNumber + 1,
          activities: [
            {
              id: Date.now(),
              activity: "",
              supportInstructions:
                selectedPlanType === 3 ? [{ id: Date.now(), text: "" }] : "",
              whatToRecord: [{ id: Date.now(), text: "" }],
              skillBuilding: "no",
              intensiveInHome: "no",
              activityNumber:
                outcome?.map((value) => value.outcomeNumber)?.[0] + 1,
            },
          ],
        },
      ]);
    } else
      setOutcome([
        ...outcome,
        {
          id: Date.now(),
          ...initialOutcome,
          outcomeNumber: outcome?.slice(-1)[0]?.outcomeNumber + 1,
          activities: [
            {
              id: Date.now(),
              activity: "",
              supportInstructions:
                selectedPlanType === 3 ? [{ id: Date.now(), text: "" }] : "",
              whatToRecord: [{ id: Date.now(), text: "" }],
              skillBuilding: "no",
              intensiveInHome: "no",
              activityNumber:
                outcome?.map((value) => value.outcomeNumber)?.[0] + 1,
            },
          ],
        },
      ]);
    setOpenedAccordion(`${outcome?.length}`);
  };

  // add new goal
  const addGoals = () => {
    if (edit) {
      setGoals([
        ...goals,
        {
          id: Date.now(),
          ...initialGoals,
          goalNumber: goals?.slice(-1)[0]?.goalNumber + 1,
          goalActivities: [
            {
              id: Date.now(),
              objectives: "",
              Intervention_Instruction: "",
              objectiveNumber: goals?.map((value) => value.goalNumber)?.[0] + 1,
            },
          ],
        },
      ]);
    } else
      setGoals([
        ...goals,
        {
          id: Date.now(),
          ...initialGoals,
          goalNumber: goals?.slice(-1)[0]?.goalNumber + 1,
          goalActivities: [
            {
              id: Date.now(),
              objectives: "",
              Intervention_Instruction: "",
              objectiveNumber: goals?.map((value) => value.goalNumber)?.[0] + 1,
            },
          ],
        },
      ]);
    setOpenedGoalAccordion(`${goals?.length}`);
  };

  // add new outcome's activities
  const addactivity = (outcomeIndex, activityNumber, activityIndex) => {
    const newActivityId = Date.now();
    if (edit) {
      setOutcome((prevOutcome) => {
        const newOutcome = JSON.parse(JSON.stringify(prevOutcome)); // Deep clone
        newOutcome[outcomeIndex].activities.push({
          id: newActivityId,
          activityNumber: `${
            outcome?.map((value) => value.outcomeNumber)?.[0]
          }${alphabet[activityIndex + 1]}`,
          activity: "",
          supportInstructions:
            selectedPlanType === 3 ? [{ id: Date.now(), text: "" }] : "",
          whatToRecord: [{ id: Date.now(), text: "" }],
          skillBuilding: "no",
          skillBuildingText: "",
          intensiveInHome: "no",
        });
        return newOutcome;
      });
    } else {
      setOutcome((prevOutcome) => {
        const newOutcome = [...prevOutcome];
        newOutcome[outcomeIndex].activities.push({
          id: newActivityId,
          activityNumber: `${
            outcome?.map((value) => value.outcomeNumber)?.[0]
          }${alphabet[activityIndex + 1]}`,
          activity: "",
          supportInstructions:
            selectedPlanType === 3 ? [{ id: Date.now(), text: "" }] : "",
          whatToRecord: [{ id: Date.now(), text: "" }],
          skillBuilding: "no",
          intensiveInHome: "no",
        });
        return newOutcome;
      });
    }
  };

  // add new goal's activities
  const addGoalActivity = (goalIndex, objectiveNumber, GoalActivityIndex) => {
    const newGoalActivityId = Date.now();
    if (edit) {
      setGoals((prevGoals) => {
        const newGoal = JSON.parse(JSON.stringify(prevGoals)); // Deep clone
        newGoal[goalIndex].goalActivities?.push({
          id: newGoalActivityId,
          objectiveNumber: `${goals?.map((value) => value.goalNumber)?.[0]}${
            alphabet[GoalActivityIndex + 1]
          }`,
          objectives: "",
          Intervention_Instruction: "",
        });
        return newGoal;
      });
    } else {
      setGoals((prevGoals) => {
        const newGoal = [...prevGoals];
        newGoal[goalIndex].goalActivities?.push({
          id: newGoalActivityId,
          objectiveNumber: `${goals?.map((value) => value.goalNumber)?.[0]}${
            alphabet[GoalActivityIndex + 1]
          }`,
          objectives: "",
          Intervention_Instruction: "",
        });
        return newGoal;
      });
    }
  };

  //remove outcome
  const removeOutcome = (id) => {
    if (outcome?.length > 1) setOutcome((p) => p?.filter((v) => v?.id != id));
  };

  //remove goals
  const removeGoals = (id) => {
    if (goals?.length > 1) setGoals((p) => p?.filter((v) => v?.id != id));
  };

  //remove Essential
  const removeEssential = (id) => {
    if (essentialSupport?.length > 1)
      setEssentialSupport((p) => p?.filter((v) => v?.id != id));
  };

  // remove outcome's activity
  const removeActivity = (id) => {
    setOutcome((prevOutcome) => {
      return prevOutcome.map((outcomeItem) => {
        return {
          ...outcomeItem,
          activities: outcomeItem.activities.filter(
            (activity) => activity.id !== id,
          ),
        };
      });
    });
  };

  // remove goal's activity
  const removeGoalActivity = (id) => {
    setGoals((prevGoal) => {
      return prevGoal.map((goalItem) => {
        return {
          ...goalItem,
          goalActivities: goalItem?.goalActivities.filter(
            (_ga) => _ga.id !== id,
          ),
        };
      });
    });
  };

  // facility change handler
  const handleFacilityChange = (f) => {
    setSelectedFacility(f);
  };

  // plan type change handler
  const handlePlanTypeChange = (t) => {
    setEssentialSupport([
      { id: Date.now(), ...initialEssentialSupport, essentialNumber: 1 },
    ]);
    setOutcome([{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }]);
    setGoals([{ id: Date.now(), ...initialGoals, goalNumber: 1 }]);
    setSelectedFacility(null);
    setEssentialSupportAdded("no");
    setSelectedServiceAndReassessDates({});
    setSelectedPlanType(
      t === types?.find((t) => t.id)?.id
        ? "1"
        : t === "67971b9c908d7890e5263bd9"
          ? 2
          : t === "697af3afc4a8059827425f67" // Service Plan ID
            ? 5
            : t === "68ae9ad573178c6bd823ac2f"
              ? 4
              : 3,
    );
    setSelected(t);
    setOpenedAccordion("0");
    setOpenedGoalAccordion("0");
  };
  // validate form
  const validateForm = () => {
    const newErrors = {};

    if (selectedPlanType != 4 && !state.endDate) {
      newErrors.endDate = "End Date is required.";
    } else if (
      selectedPlanType == 4 &&
      !selectedServiceAndReassessDates.service
    ) {
      newErrors.endDate = "Required";
    }
    if (selectedPlanType === 1) {
      outcome?.forEach((out, index) => {
        if (!out?.outcomeNumber)
          newErrors[`outcomeNumber${index}`] = "Outcome Number is required.";
        if (!out?.outcomeTitle)
          newErrors[`outcomeTitle${index}`] = "Outcome Title is required.";
        if (!out?.outcomeCategory)
          newErrors[`outcomeCategory${index}`] =
            "Outcome Category is required.";
        if (!out?.howOften)
          newErrors[`howOften${index}`] = "Outcome Frequency is required.";
        // if (showCustomOutcome[out?.id] && !out?.customOutcome) newErrors[`customOutcome${index}`] = "Custom Outcome is required.";
        // out?.activities?.forEach((act, actIndex) => {
        //   if (!act?.activity) newErrors[`supportActivity${index}-${actIndex}`] = "Support Activity is required.";
        //   if (!act?.supportInstructions) newErrors[`supportInstructions${index}-${actIndex}`] = "Support Instructions are required.";
        // });
      });
    }
    // Goal validation (only if plan type is 4)
    // if (selectedPlanType === 4) {
    //   goals?.forEach((goal, index) => {
    //     if (!goal?.goalNumber)
    //       newErrors[`goalNumber${index}`] = "Goal Number is required.";
    //     if (!goal?.Identified_Relevant_Attainable_Goals)
    //       newErrors[`goals${index}`] =
    //         "Identified Relevant Attainable Goals are required.";
    //     if (!goal?.targetBehavior)
    //       newErrors[`targetBehavior${index}`] = "Target Behavior is required.";
    //     if (!goal?.goalFrequency)
    //       newErrors[`goalFrequency${index}`] = "Goal Frequency is required.";
    //     if (!goal?.goalDuration)
    //       newErrors[`goalDuration${index}`] = "Goal Duration is required.";
    //     if (!goal?.goalTimeframe)
    //       newErrors[`goalTimeframe${index}`] = "Goal Timeframe is required.";

    //     goal?.goalActivities?.forEach((act, actIndex) => {
    //       if (!act?.objectives)
    //         newErrors[`objective${index}-${actIndex}`] =
    //           "Objective is required.";
    //       if (!act?.Intervention_Instruction)
    //         newErrors[`intervention${index}-${actIndex}`] =
    //           "Intervention Instruction is required.";
    //       if (!act?.objectiveNumber)
    //         newErrors[`objectiveNumber${index}-${actIndex}`] =
    //           "Objective Number is required.";
    //     });
    //   });
    // }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // key steps field's handlers
  const handleAddKeyStep = (outcomeId) => {
    setOutcome((prevOutcome) =>
      prevOutcome.map((outcome) =>
        outcome.id === outcomeId
          ? {
              ...outcome,
              keySteps: [...outcome.keySteps, { id: Date.now(), text: "" }],
            }
          : outcome,
      ),
    );
  };
  const handleKeyStepChange = (outcomeId, stepId, newText) => {
    setOutcome((prevOutcome) =>
      prevOutcome?.map((outcome) =>
        outcome.id === outcomeId
          ? {
              ...outcome,
              keySteps: outcome?.keySteps?.map((step) =>
                step.id === stepId ? { ...step, text: newText } : step,
              ),
            }
          : outcome,
      ),
    );
  };
  const handleRemoveKeyStep = (outcomeId, stepId) => {
    setOutcome((prevOutcome) =>
      prevOutcome?.map((outcome) =>
        outcome?.id === outcomeId
          ? {
              ...outcome,
              keySteps: outcome?.keySteps?.filter((step) => step.id !== stepId),
            }
          : outcome,
      ),
    );
  };

  const openCarePlanModal = (type, contentType) => {
    setDiscontinueType(type);
    setOpenedModal(contentType);
  };

  const closeCarePlanModal = () => {
    setSelectedFacility(null);
    setSelectedPlanType(null);
    setSelected(null);
    setSelectedServiceAndReassessDates({});
    handleTableBoxClick();
    setEssentialSupport([
      { id: Date.now(), ...initialEssentialSupport, essentialNumber: 1 },
    ]);
    setOutcome([{ id: Date.now(), ...initialOutcome, outcomeNumber: 1 }]);
    setGoals([{ id: Date.now(), ...initialGoals, goalNumber: 1 }]);
    getPlans(1, client, segment?.toLowerCase());
  
  };

  const closeModal = () => {
    setOpenedModal(null);
  };

  const servicePlanDrawerClose = async () => {
    getPlans(1, client, segment?.toLowerCase());
    getAllPlans();
    closeCarePlanModal()
  }

  const renderHeaderInputs = () => (
    !view && (
      <Box className={classes.headerContent}>
        <Select
          id="select-support-plan"
          value={selected}
          onChange={(t) => handlePlanTypeChange(t)}
          label="Plan Type"
          placeholder="Select Support Plan"
          rightSectionPointerEvents="none"
          rightSection={icon}
          data={types?.map((type) => ({
            value: type?.id,
            label: type?.name,
          }))}
          className={classes.select}
          disabled={view || edit}
          variant="filled"
        />
        <Select
          id="select-support-plan"
          value={selectedFacility}
          onChange={(f) => {
            handleFacilityChange(f);
          }}
          label="Facility"
          placeholder="Select Facility"
          rightSectionPointerEvents="none"
          rightSection={icon}
          data={allFacilities?.facilities?.map((_f) => {
            return {
              value: _f?.id,
              label: _f?.name,
              disabled: selectedClient?.facilityId?.find(
                (_fId) => _fId?.id == _f?.id,
              )
                ? false
                : clientFacilities?.find((_fId) => _fId == _f?.id)
                  ? false
                  : true,
            };
          })}
          className={classes.select}
          variant="filled"
        />
        {selectedFacility && selectedPlanType && (
          <>
            <Box mt={errors?.endDate && 20}>
              <Text>Effective Periods</Text>
              {selectedPlanType === 4 ? (
                <>
                  <ServiceAndReassessDatePicker
                    disabled={view}
                    edit={
                      selectedServiceAndReassessDates?.service?.start &&
                      selectedServiceAndReassessDates?.service?.end &&
                      selectedServiceAndReassessDates?.reassess?.length > 0
                        ? "service"
                        : undefined
                    }
                    onSave={(v) => {
                      if (
                        v &&
                        v?.service?.start &&
                        v?.service?.end &&
                        v?.reassess?.length > 0
                      ) {
                        setErrors((prevErrors) => {
                          const { endDate, ...rest } = prevErrors;
                          return rest;
                        });

                        setSelectedServiceAndReassessDates(v);
                      }
                    }}
                    savedDates={selectedServiceAndReassessDates}
                  />
                  {selectedServiceAndReassessDates?.reassess?.length > 0 &&
                    !errors?.endDate && (
                      <Text
                        fz={12}
                        ff="Inter"
                        fw={400}
                        color="#5067F9"
                        mt={2}
                        ta="center"
                      >
                        Reassess Date Selected
                      </Text>
                    )}
                </>
              ) : (
                selectedPlanType !== 4 && (
                  <>
                    <EffectivePeriodDatePicker
                      dateRange={dateRange}
                      setDateRange={setDateRange}
                      handleApply={() => {
                        setState((prevState) => ({
                          ...prevState,
                          startDate: dateRange.date[0],
                          endDate: dateRange.date[1],
                        }));
                        if (dateRange.date[1]) {
                          setErrors((prevErrors) => {
                            const { endDate, ...rest } = prevErrors;
                            return rest;
                          });
                        }
                        close();
                      }}
                      open={open}
                      opened={opened}
                      close={close}
                      value={[state.startDate, state.endDate]}
                      setTargetState={setState}
                    />
                  </>
                )
              )}

              {errors?.endDate && (
                <Text color="red" size="xs" mt={2} ff="Inter">
                  {errors?.endDate}
                </Text>
              )}
            </Box>
          </>
        )}
      </Box>
    )
  );

  return (
    <>
      <Drawer
        position="right"
        offset={20}
        zIndex={1000}
        width={1000}
        size={1000}
        opened={isOpen}
        // onClose={() => handleTableBoxClick(), setSelectedFacility(null)}
        onClose={() => {
          closeCarePlanModal();
        }}
        title={
          view
            ? rowData?.planType?.name
            : edit
              ? "Update Care Plan"
              : "Add Care Plan"
        }
        className={classes.drawer}
        overlayProps={{ opacity: 0.5, blur: 3 }}
      >
        {!view && edit && segment !== "draft" && (
          <Flex align="center" justify="end" mb={12}>
            <Switch
              checked={openedModal && discontinueType === "careplan"}
              color="yellow"
              labelPosition="left"
              label={
                <Text fz={18} ff={"Inter"} color="#262626" fw={600}>
                  Discontinue Care Plan
                </Text>
              }
              onChange={(event) => {
                event.currentTarget.checked &&
                  openCarePlanModal("careplan", "careplan");
              }}
            />
          </Flex>
        )}
        {view && (
          <Grid className={classes.profile_container} gutter={0}>
            <Grid.Col span={12}>
              <Flex gap={8} align="Center" className="profileFlex">
                <Box>
                  <img
                    src={
                      clientDetails?.imageurl
                        ? decrypt(clientDetails?.imageurl)
                        : "/assets/images/personal2.png"
                    }
                    alt="client_image"
                    className="img"
                  />
                </Box>
                <Box style={{ flex: 1 }}>
                  <p className="label">Client Name</p>
                  <h2 className="name">{rowData?.client?.name || ""}</h2>
                  <p className="id">
                    {rowData?.client?._id?.slice(0, 6) || ""}
                  </p>
                </Box>
                {/* {rowData?.isActive !== false && view && ( */}
                {view && !isStaff(profile?.user?.role) && (
                  <Box className={classes.editBtnBox}>
                    <Button
                      onClick={() => {
                        handleTableBoxClick();
                        setRowData(rowData);
                        setShowCarePlanDetails(true);
                      }}
                      type="link"
                      variant="transparent"
                      color="yellow"
                    >
                      <FiEdit size={20} />
                      Edit
                    </Button>
                  </Box>
                )}
              </Flex>
            </Grid.Col>
            <Grid.Col span={6}>
              <Box>
                <p className="label">Plan</p>
                <h2 className="name">{rowData?.planType?.name}</h2>
              </Box>
            </Grid.Col>
            <Grid.Col span={3}>
              <Box>
                <p className="label">Start Date</p>
                <h2 className="name">
                  {moment(state.startDate).format("MMM D, YYYY")}
                </h2>
              </Box>
            </Grid.Col>
            <Grid.Col span={3}>
              <Box>
                <p className="label">End Date</p>
                <h2 className="name">
                  {moment(state.endDate).format("MMM D, YYYY")}
                </h2>
              </Box>
            </Grid.Col>
          </Grid>
        )}
        {selectedPlanType !== 5 && renderHeaderInputs()}
        
        {selectedFacility && selectedPlanType !== 4 && selectedPlanType !== 5 && (
          <Box className={classes.bodyContent}>
            <Text color="#262626" fz={18} fw={600} ff={"Inter"} mb={8}>
              Outcome Details
            </Text>
            <Box className={classes.accordianParent}>
              {outcome?.length > 0 ? (
                <Accordion
                  className={classes.accordion}
                  value={openedAccordion}
                  onChange={setOpenedAccordion}
                  chevron={<IconChevronDown size={34} color="#000000" />}
                  chevronPosition="right"
                  chevronSize={20}
                  styles={{
                    chevron: {
                      transition: "transform 200ms ease",
                      "&[data-active]": {
                        transform: "rotate(180deg)",
                      },
                    },
                  }}
                >
                  {outcome?.map((out, index) => (
                    <Accordion.Item value={`${index}`}>
                      <Accordion.Control>
                        <Text
                          variant="text"
                          display="flex"
                          fw={500}
                          color="#262626"
                          fz={16}
                          ff={"Inter"}
                        >
                          {`${labels?.addNewButtonLabel}`}
                          <Text
                            ml={5}
                            className={view ? "display-on-close" : ""}
                          >{`${!view ? "#" : ""}${
                            view ? index + 1 : out?.outcomeNumber
                          }`}</Text>
                          {view && (
                            <Badge
                              color="#F78C09"
                              size="lg"
                              radius="xl"
                              variant="filled"
                              ml={8}
                              w={25}
                              h={25}
                              p={0}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              style={{
                                backgroundColor: "#F78C09",
                              }}
                            >
                              {out?.outcomeNumber}
                            </Badge>
                          )}
                        </Text>
                      </Accordion.Control>
                      <Accordion.Panel>
                        <form className="contentParent">
                          {!view && edit && segment !== "draft" && (
                            <Flex align="center" justify="end">
                              <Switch
                                checked={
                                  openedModal && discontinueType === "outcomes"
                                }
                                color="yellow"
                                disabled={out?.isActive === false}
                                labelPosition="left"
                                label={
                                  <Text
                                    fz={18}
                                    ff={"Inter"}
                                    color="#262626"
                                    fw={600}
                                  >
                                    Discontinue Outcome
                                  </Text>
                                }
                                onChange={(event) => {
                                  if (event.currentTarget.checked) {
                                    openCarePlanModal("outcomes", "outcomes");
                                    setOutcomeId(out?.id);
                                  }
                                }}
                              />
                            </Flex>
                          )}
                          {!view && (
                            <Box className={classes.outcomeDeleteBTN}>
                              <Button onClick={() => removeOutcome(out?.id)}>
                                <AiOutlineDelete size={20} />
                                Delete
                              </Button>
                            </Box>
                          )}

                          {!view && (
                            <NumberInput
                              className={classes.outcomeNumberInput}
                              label={labels?.outcomeNumberLabel}
                              size="sm"
                              type="number"
                              variant="filled"
                              value={out?.outcomeNumber || index + 1}
                              onChange={(value) => {
                                handleOutcomeChange(
                                  out?.id,
                                  "outcomeNumber",
                                  value,
                                );
                              }}
                              placeholder="Enter outcome number"
                              error={errors[`outcomeNumber${index}`]}
                              icon={
                                <ActionIcon
                                  className={classes.inc_dec_Btn}
                                  size="xs"
                                  onClick={() =>
                                    handleOutcomeChange(
                                      out?.id,
                                      "outcomeNumber",
                                      (out?.outcomeNumber || index + 1) - 1,
                                    )
                                  }
                                >
                                  <FaMinus size={15} color="#000" />
                                </ActionIcon>
                              }
                              rightSection={
                                <ActionIcon
                                  className={classes.inc_dec_Btn}
                                  onClick={() =>
                                    handleOutcomeChange(
                                      out?.id,
                                      "outcomeNumber",
                                      (out?.outcomeNumber || index + 1) + 1,
                                    )
                                  }
                                >
                                  <FaPlus size={15} color="#000" />
                                </ActionIcon>
                              }
                            />
                          )}
                          <Grid gutter={24}>
                            <Grid.Col span={12} sm={6}>
                              {view ? (
                                <Box>
                                  <Text
                                    color="#737373"
                                    fz={14}
                                    fw={400}
                                    ff="Inter"
                                  >
                                    Title
                                  </Text>
                                  <Text
                                    color="#262626"
                                    fz={16}
                                    fw={600}
                                    ff="Inter"
                                  >
                                    {out?.outcomeTitle}
                                  </Text>
                                </Box>
                              ) : (
                                <TextInput
                                  id="add-care-title"
                                  className={classes.input}
                                  label={labels?.outcomeTitleLabel}
                                  variant="filled"
                                  size="sm"
                                  placeholder={`Enter ${labels?.addNewButtonLabel} title`}
                                  disabled={view}
                                  value={out?.outcomeTitle}
                                  onChange={(e) => {
                                    handleOutcomeChange(
                                      out?.id,
                                      "outcomeTitle",
                                      e?.target?.value,
                                    );
                                  }}
                                  error={errors[`outcomeTitle${index}`]}
                                />
                              )}
                            </Grid.Col>
                            <Grid.Col span={12} sm={6}>
                              {view ? (
                                <Box>
                                  <Text
                                    color="#737373"
                                    fz={14}
                                    fw={400}
                                    ff="Inter"
                                  >
                                    Category
                                  </Text>
                                  <Text
                                    color="#262626"
                                    fz={16}
                                    fw={600}
                                    ff="Inter"
                                  >
                                    {out?.outcomeCategory}
                                  </Text>
                                </Box>
                              ) : (
                                <Select
                                  id="add-care-category"
                                  className={classes.select}
                                  label={labels?.outcomeCategoryLabel}
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                  variant="filled"
                                  size="sm"
                                  data={labels?.categoryData}
                                  placeholder={`Select ${labels?.outcomeCategoryLabel}`}
                                  value={out?.outcomeCategory}
                                  onChange={(value) => {
                                    handleOutcomeChange(
                                      out?.id,
                                      "outcomeCategory",
                                      value,
                                    );
                                    setShowCustomOutcome((p) => ({
                                      ...p,
                                      [out?.id]: value === "Other",
                                    }));
                                  }}
                                  disabled={view}
                                  error={errors[`outcomeCategory${index}`]}
                                />
                              )}
                            </Grid.Col>
                            {selectedPlanType === 3 && (
                              <>
                                <Grid.Col span={12}>
                                  <Textarea
                                    id="add-care-note"
                                    autosize={view}
                                    minRows={4}
                                    maxRows={10}
                                    className={classes.textArea}
                                    size="sm"
                                    variant="filled"
                                    label="Desired Outcome"
                                    placeholder="Enter desired outcome"
                                    readOnly={view}
                                    value={out?.desiredOutcome}
                                    onChange={(e) => {
                                      handleOutcomeChange(
                                        out?.id,
                                        "desiredOutcome",
                                        e?.target?.value,
                                      );
                                    }}
                                  />
                                </Grid.Col>
                                <Grid.Col span={12}>
                                  <Box className={classes.keyStepsBox}>
                                    <Box className={classes.keyStepsText}>
                                      <Text
                                        fz={14}
                                        fw={600}
                                        ff={"Inter"}
                                        color="#262626"
                                      >
                                        Key steps and services to get there
                                      </Text>
                                    </Box>
                                    {out?.keySteps?.map((step, stepIndex) => (
                                      <Flex
                                        w={"100%"}
                                        key={step.id}
                                        gap={"16px"}
                                        align="center"
                                        justifyContent="center"
                                        pt={"13px"}
                                        px={"8px"}
                                      >
                                        <Text>{stepIndex + 1}.</Text>
                                        <Textarea
                                          value={step.text}
                                          autosize
                                          style={{
                                            flex: 1,
                                          }}
                                          className={classes.input}
                                          size="sm"
                                          disabled={view}
                                          onChange={(e) =>
                                            handleKeyStepChange(
                                              out.id,
                                              step.id,
                                              e.target.value,
                                            )
                                          }
                                          placeholder="Enter key step"
                                        />
                                        {!view && out?.keySteps?.length > 1 && (
                                          <Button
                                            className={classes.inc_dec_Btn}
                                            onClick={() =>
                                              handleRemoveKeyStep(
                                                out.id,
                                                step.id,
                                              )
                                            }
                                            color="#FFF"
                                          >
                                            <FaMinus size={15} color="#000" />
                                          </Button>
                                        )}
                                        {!view &&
                                          stepIndex ===
                                            out?.keySteps?.length - 1 && (
                                            <Button
                                              color="#FFF"
                                              className={classes.inc_dec_Btn}
                                              onClick={() =>
                                                handleAddKeyStep(out.id)
                                              }
                                            >
                                              <FaPlus size={15} color="#000" />
                                            </Button>
                                          )}
                                      </Flex>
                                    ))}
                                  </Box>
                                </Grid.Col>
                              </>
                            )}
                            <Grid.Col span={12}>
                              <Text
                                variant="text"
                                ff={"Inter"}
                                fw={600}
                                fz={"18px"}
                                color="#000"
                              >
                                {`${labels?.typeTitle} Details`}
                              </Text>
                              {out.activities?.length > 0 &&
                                out?.activities?.map((act, actIndex) => (
                                  <Group key={act.id} gap={24} mt={24}>
                                    <Box
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                      }}
                                    >
                                      <Box className={classes.activitiesBox}>
                                        <Box
                                          className={classes.activityBoxHeader}
                                        >
                                          <p disabled={view}>
                                            {`${out?.outcomeNumber}${alphabet[actIndex]}` ||
                                              index + 1}
                                          </p>
                                          {out.activities?.length > 1 &&
                                            !view && (
                                              <ActionIcon
                                                onClick={() =>
                                                  removeActivity(act?.id)
                                                }
                                              >
                                                <IoClose
                                                  color="#000"
                                                  size={20}
                                                />
                                              </ActionIcon>
                                            )}
                                        </Box>
                                        <Box className={classes.activityFields}>
                                          {!view &&
                                            edit &&
                                            segment !== "draft" && (
                                              <Flex
                                                align="center"
                                                justify="end"
                                              >
                                                <Switch
                                                  checked={
                                                    openedModal &&
                                                    discontinueType ===
                                                      "activities"
                                                  }
                                                  color="yellow"
                                                  disabled={
                                                    act?.isActive === false ||
                                                    out?.isActive === false
                                                  }
                                                  labelPosition="left"
                                                  label={
                                                    <Text
                                                      fz={18}
                                                      ff={"Inter"}
                                                      color="#262626"
                                                      fw={600}
                                                    >
                                                      Discontinue Activity
                                                    </Text>
                                                  }
                                                  onChange={(event) => {
                                                    if (
                                                      event.currentTarget
                                                        .checked
                                                    ) {
                                                      openCarePlanModal(
                                                        "activities",
                                                        "activities",
                                                      );
                                                      setActivtyId(act?.id);
                                                      setOutcomeId(out?.id);
                                                    }
                                                  }}
                                                />
                                              </Flex>
                                            )}
                                          <Grid gutter={14}>
                                            <Grid.Col span={12} sm={6}>
                                              {/* Support Activity */}
                                              <Textarea
                                                id="add-care-activity"
                                                autosize={view}
                                                className={classes.textArea}
                                                w="100%"
                                                label={
                                                  labels?.supportActivityLabel
                                                }
                                                size="sm"
                                                minRows={4}
                                                maxRows={10}
                                                readOnly={view}
                                                placeholder="Enter activity"
                                                value={act?.supportActivity}
                                                onChange={(e) => {
                                                  handleactivityChange(
                                                    out?.id,
                                                    "supportActivity",
                                                    e?.target?.value,
                                                    act?.id,
                                                  );
                                                }}
                                              />
                                            </Grid.Col>
                                            {selectedPlanType !== 3 && (
                                              <Grid.Col span={12} sm={6}>
                                                {/* Support Instruction */}

                                                <Textarea
                                                  id="add-care-instruction"
                                                  label={
                                                    labels?.supportInstructionsLabel
                                                  }
                                                  autosize={view}
                                                  className={classes.textArea}
                                                  w="100%"
                                                  size="sm"
                                                  minRows={4}
                                                  maxRows={10}
                                                  placeholder={`Enter ${labels?.supportInstructionsLabel.toLowerCase()}`}
                                                  readOnly={view}
                                                  value={
                                                    act?.supportInstructions
                                                  }
                                                  onChange={(e) => {
                                                    handleactivityChange(
                                                      out?.id,
                                                      "supportInstructions",
                                                      e?.target?.value,
                                                      act?.id,
                                                    );
                                                  }}
                                                />
                                              </Grid.Col>
                                            )}
                                            {selectedPlanType === 3 && (
                                              <>
                                                <Grid.Col span={12} sm={6}>
                                                  {/* I no longer want/need supports when */}

                                                  <Textarea
                                                    id="add-care-activity"
                                                    w={"100%"}
                                                    label={
                                                      "I no longer want/need supports when"
                                                    }
                                                    autosize={view}
                                                    className={classes.textArea}
                                                    size="sm"
                                                    minRows={4}
                                                    maxRows={10}
                                                    readOnly={view}
                                                    placeholder="Enter Response"
                                                    value={
                                                      act?.iNoLongerNeedThisSupportWhen
                                                    }
                                                    onChange={(e) => {
                                                      handleactivityChange(
                                                        out?.id,
                                                        "iNoLongerNeedThisSupportWhen",
                                                        e?.target?.value,
                                                        act?.id,
                                                      );
                                                    }}
                                                  />
                                                </Grid.Col>
                                                <Grid.Col span={12}>
                                                  {" "}
                                                  <Box
                                                    className={
                                                      classes.keyStepsBox
                                                    }
                                                  >
                                                    <Box
                                                      className={
                                                        classes.keyStepsText
                                                      }
                                                    >
                                                      <Text
                                                        fz={14}
                                                        fw={600}
                                                        ff={"Inter"}
                                                        color="#262626"
                                                      >
                                                        {
                                                          labels?.supportInstructionsLabel
                                                        }
                                                      </Text>
                                                    </Box>
                                                    {Array.isArray(
                                                      act?.supportInstructions,
                                                    ) &&
                                                      act?.supportInstructions?.map(
                                                        (
                                                          supportIns,
                                                          supportInsIndex,
                                                        ) => (
                                                          <Flex
                                                            w={"100%"}
                                                            key={supportIns.id}
                                                            gap={"16px"}
                                                            align="center"
                                                            justifyContent="center"
                                                            pt={"13px"}
                                                            px={"8px"}
                                                          >
                                                            <Text>
                                                              {supportInsIndex +
                                                                1}
                                                              .
                                                            </Text>
                                                            <Textarea
                                                              value={
                                                                supportIns.text
                                                              }
                                                              autosize
                                                              style={{
                                                                flex: 1,
                                                              }}
                                                              className={
                                                                classes.input
                                                              }
                                                              size="sm"
                                                              disabled={view}
                                                              onChange={(e) =>
                                                                handleactivityChange(
                                                                  out?.id,
                                                                  "supportInstructions",
                                                                  act.supportInstructions?.map(
                                                                    (v) =>
                                                                      v.id ===
                                                                      supportIns.id
                                                                        ? {
                                                                            ...v,
                                                                            text: e
                                                                              .target
                                                                              .value,
                                                                          }
                                                                        : v,
                                                                  ),
                                                                  act?.id,
                                                                )
                                                              }
                                                              placeholder={`Enter ${labels?.supportInstructionsLabel.toLowerCase()}`}
                                                            />
                                                            {!view &&
                                                              act
                                                                ?.supportInstructions
                                                                ?.length >
                                                                1 && (
                                                                <Button
                                                                  className={
                                                                    classes.inc_dec_Btn
                                                                  }
                                                                  onClick={() =>
                                                                    handleactivityChange(
                                                                      out?.id,
                                                                      "supportInstructions",
                                                                      act.supportInstructions?.filter(
                                                                        (v) =>
                                                                          v.id !==
                                                                          supportIns.id,
                                                                      ),
                                                                      act?.id,
                                                                    )
                                                                  }
                                                                  color="#FFF"
                                                                >
                                                                  <FaMinus
                                                                    size={15}
                                                                    color="#000"
                                                                  />
                                                                </Button>
                                                              )}
                                                            {!view &&
                                                              supportInsIndex ===
                                                                act
                                                                  ?.supportInstructions
                                                                  ?.length -
                                                                  1 && (
                                                                <Button
                                                                  color="#FFF"
                                                                  className={
                                                                    classes.inc_dec_Btn
                                                                  }
                                                                  onClick={() =>
                                                                    handleactivityChange(
                                                                      out?.id,
                                                                      "supportInstructions",
                                                                      [
                                                                        ...act.supportInstructions,
                                                                        {
                                                                          id: Date.now(),
                                                                          text: "",
                                                                        },
                                                                      ],
                                                                      act?.id,
                                                                    )
                                                                  }
                                                                >
                                                                  <FaPlus
                                                                    size={15}
                                                                    color="#000"
                                                                  />
                                                                </Button>
                                                              )}
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </Box>
                                                </Grid.Col>
                                                {/* <Grid.Col span={12}>
                                                  <Textarea
                                                    id="add-care-instruction"
                                                    autosize={view}
                                                    className={classes.textArea}
                                                    w="100%"
                                                    minRows={4}
                                                    maxRows={10}
                                                    label="What to record"
                                                    size="sm"
                                                    placeholder={`Enter Additional Note`}
                                                    readOnly={view}
                                                    value={act?.whatToRecord}
                                                    onChange={(e) => {
                                                      handleactivityChange(
                                                        out?.id,
                                                        "whatToRecord",
                                                        e?.target?.value,
                                                        act?.id
                                                      );
                                                    }}
                                                  />
                                                </Grid.Col> */}
                                                <Grid.Col span={12}>
                                                  {" "}
                                                  <Box
                                                    className={
                                                      classes.keyStepsBox
                                                    }
                                                  >
                                                    <Box
                                                      className={
                                                        classes.keyStepsText
                                                      }
                                                    >
                                                      <Text
                                                        fz={14}
                                                        fw={600}
                                                        ff={"Inter"}
                                                        color="#262626"
                                                      >
                                                        What to record
                                                      </Text>
                                                    </Box>
                                                    {act?.whatToRecord &&
                                                      Array.isArray(
                                                        act?.whatToRecord,
                                                      ) &&
                                                      act?.whatToRecord?.map(
                                                        (
                                                          record,
                                                          recordIndex,
                                                        ) => (
                                                          <Flex
                                                            w={"100%"}
                                                            key={record.id}
                                                            gap={"16px"}
                                                            align="center"
                                                            justifyContent="center"
                                                            pt={"13px"}
                                                            px={"8px"}
                                                          >
                                                            <Text>
                                                              {recordIndex + 1}.
                                                            </Text>
                                                            <Textarea
                                                              value={
                                                                record.text
                                                              }
                                                              autosize
                                                              style={{
                                                                flex: 1,
                                                              }}
                                                              className={
                                                                classes.input
                                                              }
                                                              size="sm"
                                                              disabled={view}
                                                              onChange={(e) =>
                                                                handleactivityChange(
                                                                  out?.id,
                                                                  "whatToRecord",
                                                                  act.whatToRecord?.map(
                                                                    (v) =>
                                                                      v.id ===
                                                                      record.id
                                                                        ? {
                                                                            ...v,
                                                                            text: e
                                                                              .target
                                                                              .value,
                                                                          }
                                                                        : v,
                                                                  ),
                                                                  act?.id,
                                                                )
                                                              }
                                                              placeholder="Enter Additional Note"
                                                            />
                                                            {!view &&
                                                              act?.whatToRecord
                                                                ?.length >
                                                                1 && (
                                                                <Button
                                                                  className={
                                                                    classes.inc_dec_Btn
                                                                  }
                                                                  onClick={() =>
                                                                    handleactivityChange(
                                                                      out?.id,
                                                                      "whatToRecord",
                                                                      act.whatToRecord?.filter(
                                                                        (v) =>
                                                                          v.id !==
                                                                          record.id,
                                                                      ),
                                                                      act?.id,
                                                                    )
                                                                  }
                                                                  color="#FFF"
                                                                >
                                                                  <FaMinus
                                                                    size={15}
                                                                    color="#000"
                                                                  />
                                                                </Button>
                                                              )}
                                                            {!view &&
                                                              recordIndex ===
                                                                act
                                                                  ?.whatToRecord
                                                                  ?.length -
                                                                  1 && (
                                                                <Button
                                                                  color="#FFF"
                                                                  className={
                                                                    classes.inc_dec_Btn
                                                                  }
                                                                  onClick={() =>
                                                                    handleactivityChange(
                                                                      out?.id,
                                                                      "whatToRecord",
                                                                      [
                                                                        ...act.whatToRecord,
                                                                        {
                                                                          id: Date.now(),
                                                                          text: "",
                                                                        },
                                                                      ],
                                                                      act?.id,
                                                                    )
                                                                  }
                                                                >
                                                                  <FaPlus
                                                                    size={15}
                                                                    color="#000"
                                                                  />
                                                                </Button>
                                                              )}
                                                          </Flex>
                                                        ),
                                                      )}
                                                  </Box>
                                                </Grid.Col>
                                              </>
                                            )}
                                          </Grid>
                                          <Box
                                            className={classes.checkboxGroup}
                                          >
                                            <Checkbox
                                              key={act.id}
                                              id={actIndex + 1}
                                              checked={
                                                act?.skillBuilding === "yes"
                                              }
                                              label={"Skill-Building"}
                                              variant="outline"
                                              disabled={view}
                                              color="#404040"
                                              styles={(theme) => ({
                                                input: {
                                                  "&:checked": {
                                                    backgroundColor: "#404040",
                                                    borderColor: "#404040",
                                                  },
                                                },
                                              })}
                                              onChange={(event) => {
                                                const newChecked =
                                                  event.currentTarget.checked;
                                                const updatedChecked = [
                                                  ...checkedSkillBuilding,
                                                ];
                                                updatedChecked[actIndex] =
                                                  newChecked;
                                                setCheckedSkillBuilding(
                                                  updatedChecked,
                                                );
                                                handleactivityChange(
                                                  out?.id,
                                                  "skillBuilding",
                                                  newChecked ? "yes" : "no",
                                                  act?.id,
                                                );
                                              }}
                                            />

                                            <Checkbox
                                              key={act.id}
                                              id={actIndex + 1}
                                              checked={
                                                act?.intensiveInHome === "yes"
                                              }
                                              label={"Intensive in-home"}
                                              color="#404040"
                                              disabled={view}
                                              variant="outline"
                                              styles={(theme) => ({
                                                input: {
                                                  "&:checked": {
                                                    backgroundColor: "#404040",
                                                    borderColor: "#404040",
                                                  },
                                                },
                                              })}
                                              onChange={(event) => {
                                                const newChecked =
                                                  event.currentTarget.checked;
                                                const updatedChecked = [
                                                  ...checkedIntensiveInHome,
                                                ];
                                                updatedChecked[actIndex] =
                                                  newChecked;
                                                setCheckedIntensiveInHome(
                                                  updatedChecked,
                                                );
                                                handleactivityChange(
                                                  out?.id,
                                                  "intensiveInHome",
                                                  newChecked ? "yes" : "no",
                                                  act?.id,
                                                );
                                              }}
                                            />
                                          </Box>
                                          {selectedPlanType === 3 && (
                                            <>
                                              {act?.skillBuilding === "yes" && (
                                                <Textarea
                                                  w={"100%"}
                                                  className={classes.textArea}
                                                  placeholder="Skill description"
                                                  value={act?.skillBuildingText}
                                                  onChange={(e) =>
                                                    handleactivityChange(
                                                      out?.id,
                                                      "skillBuildingText",
                                                      e.target.value,
                                                      act?.id,
                                                    )
                                                  }
                                                  autosize
                                                  minRows={4}
                                                  maxRows={10}
                                                />
                                              )}
                                            </>
                                          )}
                                        </Box>
                                      </Box>

                                      {actIndex === out.activities.length - 1 &&
                                        !view && (
                                          <Button
                                            onClick={() =>
                                              addactivity(
                                                index,
                                                act.activityNumber
                                                  ? act.activityNumber
                                                  : "",
                                                actIndex,
                                              )
                                            }
                                            className={
                                              classes.addNewActivityBtn
                                            }
                                            ref={buttonRef}
                                          >
                                            <IconPlus size={15} />
                                            {labels?.addNewDetailsLabel}
                                          </Button>
                                        )}
                                    </Box>
                                  </Group>
                                ))}
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <Box className={classes.frequencyAndByWhen}>
                                {/* Outcome Frequency */}
                                <Select
                                  id="add-care-frequency"
                                  style={{
                                    flex: 1,
                                  }}
                                  className={classes.select}
                                  label={labels?.howOftenLabel}
                                  size="sm"
                                  data={[
                                    "Daily",
                                    "Weekly",
                                    "Twice a Week",
                                    "Monthly",
                                    "Twice a Month",
                                  ]}
                                  placeholder="Select how often you do this activity."
                                  value={out?.howOften}
                                  onChange={(value) => {
                                    handleOutcomeChange(
                                      out?.id,
                                      "howOften",
                                      value,
                                    );
                                  }}
                                  disabled={view}
                                  rightSectionPointerEvents="none"
                                  rightSection={icon}
                                  variant="filled"
                                  error={errors[`howOften${index}`]}
                                />

                                {/* ----- By when ----- */}
                                {selectedPlanType === 3 && (
                                  <DateInput
                                    w={"30%"}
                                    className={classes.dateRangePicker}
                                    icon={<IoCalendarClearOutline />}
                                    label="By When"
                                    valueFormat="MMM D, YYYY"
                                    placeholder="mm/dd/yyyy"
                                    disabled={view}
                                    value={
                                      out?.byWhen
                                        ? moment(out?.byWhen).toDate()
                                        : null
                                    }
                                    onChange={(e) => {
                                      handleOutcomeChange(out?.id, "byWhen", e);
                                    }}
                                  />
                                )}
                              </Box>
                            </Grid.Col>
                          </Grid>

                          {/* Outcome Category */}
                          {showCustomOutcome[out?.id] && (
                            <SimpleGrid
                              cols={isMobileScreen ? 1 : 2}
                              className={classes.supportPlaneTopSection}
                            >
                              <Textarea
                                autosize={view}
                                className={classes.textArea}
                                style={{ marginTop: "15px" }}
                                label="Add Custom Outcome"
                                size="sm"
                                placeholder="Enter outcome"
                                disabled={view}
                                value={out?.customOutcome}
                                onChange={(e) => {
                                  handleOutcomeChange(
                                    out?.id,
                                    "customOutcome",
                                    e?.target?.value,
                                  );
                                }}
                              />
                            </SimpleGrid>
                          )}

                          {/* I no longer need this outcome when .. */}
                          {selectedPlanType != 3 && (
                            <SimpleGrid
                              cols={isMobileScreen ? 1 : 2}
                              className={classes.mwd}
                            >
                              <>
                                <Textarea
                                  id="add-care-reason"
                                  autosize={view}
                                  label={labels?.noLongerNeedLabel}
                                  minRows={4}
                                  maxRows={10}
                                  className={classes.textArea}
                                  size="sm"
                                  placeholder="Enter response"
                                  readOnly={view}
                                  value={out?.iNoLongerNeedThisOutcome}
                                  onChange={(e) => {
                                    handleOutcomeChange(
                                      out?.id,
                                      "iNoLongerNeedThisOutcome",
                                      e?.target?.value,
                                    );
                                  }}
                                />
                                <Textarea
                                  id="add-care-note"
                                  autosize={view}
                                  label={labels?.additionalNoteLabel}
                                  minRows={4}
                                  maxRows={10}
                                  className={classes.textArea}
                                  size="sm"
                                  placeholder="Enter additional note"
                                  readOnly={view}
                                  value={out?.additionalInformation}
                                  onChange={(e) => {
                                    handleOutcomeChange(
                                      out?.id,
                                      "additionalInformation",
                                      e?.target?.value,
                                    );
                                  }}
                                />
                              </>
                            </SimpleGrid>
                          )}
                        </form>
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
                </Accordion>
              ) : (
                <NoRecord />
              )}
              {!view && (
                <Box className={classes.addAndSaveBtnParent}>
                  <Button onClick={addOutcome} className="addBtn">
                    {`Add New ${labels?.addNewButtonLabel}`}
                  </Button>
                  {((selectedPlanType === 3 &&
                    essentialSupportAdded === "no") ||
                    selectedPlanType !== 3) && (
                    <SaveButton
                      loading={addPlanLoading}
                      onClick={onSave}
                      disabled={view}
                    />
                  )}
                </Box>
              )}
            </Box>
            {selectedPlanType === 3 && (
              <>
                <Box mt={19}>
                  <Text color="#344054" fz={14} fw={500} ff={"Inter"} mb={6}>
                    Add Essential Support
                  </Text>
                  <Box className={classes.essentialSupportRadio}>
                    <Radio.Group
                      value={essentialSupportAdded}
                      onChange={(value) => {
                        setEssentialSupportAdded(value);
                        if (value === "yes") {
                          const newSupport = {
                            id: Date.now(),
                            essentialNumber: 1,
                            activities: [
                              {
                                id: Date.now(),
                                howToSupport: [{ id: Date.now(), text: "" }],
                                howOftenEssentialSupport: "",
                                supportStatement: "",
                                activityNumber: "1a",
                              },
                            ],
                          };
                          setEssentialSupport([newSupport]);
                          setOpenedEssentialAccordion(
                            newSupport?.id?.toString(),
                          );
                        }
                      }}
                      defaultValue="no"
                    >
                      <Flex gap={"24px"} align="center">
                        <Radio
                          value="yes"
                          label="Yes"
                          disabled={view}
                          variant="outline"
                          styles={(theme) => ({
                            radio: {
                              "&:checked": {
                                backgroundColor: "#000000",
                                borderColor: "#000000",
                              },
                            },
                          })}
                        />
                        <Radio
                          value="no"
                          disabled={view}
                          label="No"
                          styles={(theme) => ({
                            radio: {
                              "&:checked": {
                                backgroundColor: "#000000",
                                borderColor: "#000000",
                              },
                            },
                          })}
                          variant="outline"
                        />
                      </Flex>
                    </Radio.Group>
                  </Box>
                </Box>

                {essentialSupportAdded === "yes" && (
                  <Box mt={28}>
                    <Text
                      color="#262626"
                      fz={"18px"}
                      fw={600}
                      ff={"Inter"}
                      mb={11}
                    >
                      Essential Support Details
                    </Text>
                    <Box className={classes.accordianParent}>
                      <Accordion
                        value={openedEssentialAccordion}
                        onChange={setOpenedEssentialAccordion}
                        chevron={<IconChevronDown size={34} color="gray" />}
                        className={classes.accordion}
                        chevronPosition="right"
                        styles={{
                          chevron: {
                            "&[data-active]": { transform: "rotate(180deg)" },
                          },
                        }}
                      >
                        {essentialSupport?.map((support, index) => (
                          <Accordion.Item
                            key={support?.id}
                            value={support?.id.toString()}
                          >
                            <Accordion.Control>
                              <Text
                                variant="text"
                                display="flex"
                                fw={500}
                                color="#262626"
                                fz={16}
                                ff={"Inter"}
                              >
                                Essential Support{" "}
                                <Text
                                  ml={5}
                                  className={view ? "display-on-close" : ""}
                                >
                                  {`${!view ? "#" : ""}${
                                    view ? index + 1 : support?.essentialNumber
                                  }`}
                                </Text>
                                {view && (
                                  <Badge
                                    color="#F78C09"
                                    size="lg"
                                    radius="xl"
                                    variant="filled"
                                    w={25}
                                    h={25}
                                    ml={8}
                                    p={0}
                                    display="flex"
                                    alignItems="center"
                                    style={{
                                      backgroundColor: "#F78C09",
                                    }}
                                    justifyContent="center"
                                  >
                                    {support?.essentialNumber}
                                  </Badge>
                                )}
                              </Text>
                            </Accordion.Control>
                            <Accordion.Panel>
                              <Box className="contentParent">
                                {!view && (
                                  <Flex
                                    align="end"
                                    justify="flex-end"
                                    className={classes.outcomeDeleteBTN}
                                  >
                                    <Button
                                      onClick={() => {
                                        removeEssential(support?.id);
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </Flex>
                                )}
                                {!view && (
                                  <Box
                                    className={
                                      classes.essentialSupportNumberBox
                                    }
                                  >
                                    <ActionIcon
                                      className={classes.inc_dec_Btn}
                                      onClick={() =>
                                        handleEssentialSupportChange(
                                          support.id,
                                          "essentialNumber",
                                          Math.max(
                                            1,
                                            (support.essentialNumber || 1) - 1,
                                          ),
                                        )
                                      }
                                    >
                                      <FaMinus size={15} color="#000" />
                                    </ActionIcon>
                                    <NumberInput
                                      variant="unstyled"
                                      value={
                                        support?.essentialNumber || index + 1
                                      }
                                      onChange={(value) => {
                                        handleEssentialSupportChange(
                                          support?.id,
                                          "essentialNumber",
                                          value,
                                        );
                                      }}
                                      placeholder="Enter outcome number"
                                      required
                                      error={errors[`essentialNumber${index}`]}
                                    />
                                    <ActionIcon
                                      className={classes.inc_dec_Btn}
                                      onClick={() =>
                                        handleEssentialSupportChange(
                                          support.id,
                                          "essentialNumber",
                                          (support.essentialNumber || 1) + 1,
                                        )
                                      }
                                    >
                                      <FaPlus size={15} color="#000" />
                                    </ActionIcon>
                                  </Box>
                                )}
                                <SimpleGrid
                                  cols={isMobileScreen ? 1 : 2}
                                  spacing={24}
                                  className={classes.essentialSupportFieldBox}
                                >
                                  <Select
                                    label="Essential Support Type"
                                    disabled={view}
                                    className={classes.select}
                                    placeholder="Select Essential Support Type"
                                    value={support?.essentialSupportType}
                                    onChange={(value) =>
                                      handleEssentialSupportChange(
                                        support.id,
                                        "essentialSupportType",
                                        value,
                                      )
                                    }
                                    data={[
                                      "Identified Risk",
                                      "Potential Risk",
                                      "Routine Support",
                                    ]}
                                    rightSection={
                                      <IconChevronDown size={24} color="gray" />
                                    }
                                  />
                                  <DatePickerInput
                                    type="range"
                                    label="Effective Periods"
                                    disabled={view}
                                    placeholder="Select start and end dates"
                                    className={classes.dateRangePicker}
                                    valueFormat="MMM D, YYYY"
                                    value={support.effectivePeriods}
                                    onChange={(value) =>
                                      handleEssentialSupportChange(
                                        support.id,
                                        "effectivePeriods",
                                        value,
                                      )
                                    }
                                  />
                                </SimpleGrid>
                                <Text
                                  color="#000"
                                  fz={18}
                                  fw={600}
                                  ff={"Inter"}
                                >
                                  Essential Support Activities
                                </Text>
                                {support?.activities?.map(
                                  (activity, actIndex) => (
                                    <>
                                      <Box
                                        key={activity?.id}
                                        className={classes.essentialActivities}
                                      >
                                        <Box
                                          className={classes.activityBoxHeader}
                                        >
                                          <p>
                                            {`${support?.essentialNumber}${alphabet[actIndex]}` ||
                                              actIndex + 1}
                                          </p>
                                          {support?.activities?.length > 1 &&
                                            !view && (
                                              <ActionIcon
                                                onClick={() =>
                                                  removeEssentialActivity(
                                                    support?.id,
                                                    activity?.id,
                                                  )
                                                }
                                              >
                                                <IoClose
                                                  color="#000"
                                                  size={20}
                                                />
                                              </ActionIcon>
                                            )}
                                        </Box>
                                        <Box
                                          className={
                                            classes.statementAndSupport
                                          }
                                        >
                                          <Box
                                            className={
                                              classes.statementSupportParent
                                            }
                                          >
                                            <Box className={classes.supportBox}>
                                              <Textarea
                                                label="Support Statement"
                                                readOnly={view}
                                                value={
                                                  activity?.supportStatement
                                                }
                                                onChange={(e) =>
                                                  handleEssentialActivityChange(
                                                    support?.id,
                                                    activity?.id,
                                                    "supportStatement",
                                                    e.target.value,
                                                  )
                                                }
                                                minRows={5}
                                                placeholder="Enter support statement"
                                                className={classes.textArea}
                                                w={"100%"}
                                              />
                                            </Box>
                                            {/* <Box
                                              className={`${classes.supportBox} ${classes.instructionsBox}`}
                                            >
                                              <Textarea
                                                value={activity?.howToSupport}
                                                label="How To Support"
                                                readOnly={view}
                                                onChange={(e) =>
                                                  handleEssentialActivityChange(
                                                    support.id,
                                                    activity?.id,
                                                    "howToSupport",
                                                    e.target.value
                                                  )
                                                }
                                                minRows={5}
                                                placeholder="Enter support instructions"
                                                className={classes.textArea}
                                                w={"100%"}
                                              />
                                            </Box> */}
                                            <Box
                                              className={classes.keyStepsBox}
                                            >
                                              <Box
                                                className={classes.keyStepsText}
                                              >
                                                <Text
                                                  fz={14}
                                                  fw={600}
                                                  ff={"Inter"}
                                                  color="#262626"
                                                >
                                                  How To Support
                                                </Text>
                                              </Box>
                                              {Array.isArray(
                                                activity?.howToSupport,
                                              ) &&
                                                activity?.howToSupport?.map(
                                                  (
                                                    suppRecord,
                                                    suppRecordIndex,
                                                  ) => (
                                                    <Flex
                                                      w={"100%"}
                                                      key={suppRecord.id}
                                                      gap={"16px"}
                                                      align="center"
                                                      justifyContent="center"
                                                      pt={"13px"}
                                                      px={"8px"}
                                                    >
                                                      <Text>
                                                        {suppRecordIndex + 1}.
                                                      </Text>
                                                      <Textarea
                                                        value={suppRecord.text}
                                                        autosize
                                                        style={{
                                                          flex: 1,
                                                        }}
                                                        className={
                                                          classes.input
                                                        }
                                                        size="sm"
                                                        readOnly={view}
                                                        onChange={(e) =>
                                                          handleEssentialActivityChange(
                                                            support.id,
                                                            activity?.id,
                                                            "howToSupport",
                                                            activity?.howToSupport?.map(
                                                              (v) =>
                                                                v.id ===
                                                                suppRecord.id
                                                                  ? {
                                                                      ...v,
                                                                      text: e
                                                                        .target
                                                                        .value,
                                                                    }
                                                                  : v,
                                                            ),
                                                          )
                                                        }
                                                        placeholder="Enter Additional Note"
                                                      />
                                                      {!view &&
                                                        activity?.howToSupport
                                                          ?.length > 1 && (
                                                          <Button
                                                            className={
                                                              classes.inc_dec_Btn
                                                            }
                                                            onClick={() =>
                                                              handleEssentialActivityChange(
                                                                support.id,
                                                                activity?.id,
                                                                "howToSupport",
                                                                activity?.howToSupport?.filter(
                                                                  (v) =>
                                                                    v.id !==
                                                                    suppRecord.id,
                                                                ),
                                                              )
                                                            }
                                                            color="#FFF"
                                                          >
                                                            <FaMinus
                                                              size={15}
                                                              color="#000"
                                                            />
                                                          </Button>
                                                        )}
                                                      {!view &&
                                                        suppRecordIndex ===
                                                          activity?.howToSupport
                                                            ?.length -
                                                            1 && (
                                                          <Button
                                                            color="#FFF"
                                                            className={
                                                              classes.inc_dec_Btn
                                                            }
                                                            onClick={() =>
                                                              handleEssentialActivityChange(
                                                                support.id,
                                                                activity?.id,
                                                                "howToSupport",
                                                                [
                                                                  ...activity?.howToSupport,
                                                                  {
                                                                    id: Date.now(),
                                                                    text: "",
                                                                  },
                                                                ],
                                                              )
                                                            }
                                                          >
                                                            <FaPlus
                                                              size={15}
                                                              color="#000"
                                                            />
                                                          </Button>
                                                        )}
                                                    </Flex>
                                                  ),
                                                )}
                                            </Box>
                                            <Select
                                              className={classes.select}
                                              disabled={view}
                                              label="How Often"
                                              placeholder="Select option"
                                              rightSection={
                                                <IconChevronDown
                                                  size={24}
                                                  color="gray"
                                                />
                                              }
                                              // value={activity?.howOftenEssentialSupport}
                                              value={
                                                activity?.howOftenEssentialSupport ??
                                                support?.howOftenEssentialSupport ??
                                                ""
                                              }
                                              data={[
                                                "Daily",
                                                "Weekly",
                                                "Monthly",
                                                "Quarterly",
                                                "Semi-annually",
                                                "Annually",
                                                "Routinely as needed",
                                                "Emergency support only",
                                              ]}
                                              // onChange={(value) => {
                                              //   // Update logic: if the new format has it inside activity, update that;
                                              //   // otherwise, update at the parent support level.
                                              //   if (
                                              //     "howOftenEssentialSupport" in
                                              //     activity
                                              //   ) {
                                              //     handleEssentialActivityChange(
                                              //       support.id,
                                              //       activity?.id,
                                              //       "howOftenEssentialSupport",
                                              //       value
                                              //     );
                                              //   } else {
                                              //     handleEssentialActivityChange(
                                              //       support.id,
                                              //       null, // no activity ID for old structure
                                              //       "howOftenEssentialSupport",
                                              //       value
                                              //     );
                                              //   }
                                              // }}
                                              onChange={(value) =>
                                                handleEssentialActivityChange(
                                                  support.id,
                                                  activity?.id,
                                                  "howOftenEssentialSupport",
                                                  value,
                                                )
                                              }
                                            />
                                          </Box>
                                        </Box>
                                      </Box>
                                      {!view &&
                                        actIndex ===
                                          support?.activities?.length - 1 && (
                                          <Button
                                            onClick={() =>
                                              addEssentialActivity(
                                                support.id,
                                                actIndex,
                                              )
                                            }
                                            className={
                                              classes.addNewActivityBtn
                                            }
                                          >
                                            <IconPlus size={15} />
                                            Add More Support Details
                                          </Button>
                                        )}
                                    </>
                                  ),
                                )}
                              </Box>
                            </Accordion.Panel>
                          </Accordion.Item>
                        ))}
                      </Accordion>
                      {!view && (
                        <Box className={classes.addAndSaveBtnParent}>
                          <Button
                            size="sm"
                            className="addBtn"
                            onClick={() => {
                              const newSupport = {
                                id: Date.now(),
                                ...initialEssentialSupport,
                                essentialNumber:
                                  essentialSupport?.slice(-1)[0]
                                    ?.essentialNumber + 1,
                                activities: [
                                  {
                                    id: Date.now(),
                                    howToSupport: [
                                      { id: Date.now(), text: "" },
                                    ],
                                    supportStatement: "",
                                    activity: "",
                                    howOftenEssentialSupport: "",
                                    activityNumber: `${
                                      essentialSupport?.length + 1
                                    }${alphabet[0]}`,
                                  },
                                ],
                              };
                              setEssentialSupport((prev) => [
                                ...prev,
                                newSupport,
                              ]);
                              setOpenedEssentialAccordion(
                                newSupport.id.toString(),
                              );
                            }}
                          >
                            Add New Essential Support
                          </Button>
                          {essentialSupportAdded === "yes" && (
                            <SaveButton
                              loading={addPlanLoading}
                              onClick={onSave}
                              disabled={view}
                            />
                          )}
                        </Box>
                      )}
                    </Box>
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
        {selectedFacility && selectedPlanType === 4 && (
          <>
            {selectedServiceAndReassessDates?.reassess?.length > 0 && (
              <Box pt={18} pb={12}>
                <Text fz={18} ff="Inter" fw={600} mb={10} color="#5067F9">
                  Reassess Dates
                </Text>
                <Box className={classes.reassessDatesContainer}>
                  <Grid gutter={30}>
                    {selectedServiceAndReassessDates?.reassess?.map(
                      (data, index) => (
                        <Grid.Col span={4} key={index}>
                          <Box className={classes.reassessDateBox}>
                            <Flex align="center" justify="space-between">
                              <Text fz={14} fw={500} ff="Inter" color="#262626">
                                {data?.title}
                              </Text>
                              <LuInfo size={18} color="#D4D4D4" />
                            </Flex>
                            <ServiceAndReassessDatePicker
                              edit="reassess"
                              editReassessDate={data}
                              disabled={view}
                              savedDates={selectedServiceAndReassessDates}
                              onSave={(v) => {
                                if (
                                  v &&
                                  v?.service?.start &&
                                  v?.service?.end &&
                                  v?.reassess?.length > 0
                                ) {
                                  setErrors((prevErrors) => {
                                    const { endDate, ...rest } = prevErrors;
                                    return rest;
                                  });

                                  setSelectedServiceAndReassessDates(v);
                                }
                              }}
                            />
                            {/* <Box className={classes.reassessDateLabel}>
                              <MdOutlineCalendarToday
                                size={18}
                                color="#262626"
                              />
                              {label}
                            </Box> */}
                          </Box>
                        </Grid.Col>
                      ),
                    )}
                  </Grid>
                </Box>
              </Box>
            )}
            <Text color="#262626" fz={18} fw={600} ff={"Inter"} my={10}>
              Goal Details
            </Text>
            <Box className={classes.accordianParent}>
              {goals?.length > 0 ? (
                <Accordion
                  className={classes.accordion}
                  value={openedGoalAccordion}
                  onChange={setOpenedGoalAccordion}
                  chevron={<IconChevronDown size={34} color="#000000" />}
                  chevronPosition="right"
                  chevronSize={20}
                  styles={{
                    chevron: {
                      transition: "transform 200ms ease",
                      "&[data-active]": {
                        transform: "rotate(180deg)",
                      },
                    },
                  }}
                >
                  {goals?.map((goal, index) => (
                    <Accordion.Item value={`${index}`}>
                      <Accordion.Control>
                        <Text
                          variant="text"
                          display="flex"
                          fw={500}
                          color="#262626"
                          fz={16}
                          ff={"Inter"}
                        >
                          {`${labels?.addNewButtonLabel}`}
                          <Text
                            ml={5}
                            className={view ? "display-on-close" : ""}
                          >{`${!view ? "#" : ""}${
                            view ? index + 1 : goal?.goalNumber
                          }`}</Text>
                          {view && (
                            <Badge
                              color="#F78C09"
                              size="lg"
                              radius="xl"
                              variant="filled"
                              ml={8}
                              w={25}
                              h={25}
                              p={0}
                              display="flex"
                              alignItems="center"
                              justifyContent="center"
                              style={{
                                backgroundColor: "#F78C09",
                              }}
                            >
                              {goal?.goalNumber}
                            </Badge>
                          )}
                        </Text>
                      </Accordion.Control>
                      <Accordion.Panel>
                        <form className="contentParent">
                          {!view && edit && segment !== "draft" && (
                            <Flex align="center" justify="end">
                              <Switch
                                checked={
                                  openedModal && discontinueType === "goal"
                                }
                                color="yellow"
                                disabled={goal?.isActive === false}
                                labelPosition="left"
                                label={
                                  <Text
                                    fz={18}
                                    ff={"Inter"}
                                    color="#262626"
                                    fw={600}
                                  >
                                    Discontinue Goal
                                  </Text>
                                }
                                onChange={(event) => {
                                  if (event.currentTarget.checked) {
                                    openCarePlanModal("goal", "goal");
                                    setOutcomeId(goal?.id);
                                  }
                                }}
                              />
                            </Flex>
                          )}
                          {!view && (
                            <Box className={classes.outcomeDeleteBTN}>
                              <Button onClick={() => removeGoals(goal?.id)}>
                                <AiOutlineDelete size={20} />
                                Delete
                              </Button>
                            </Box>
                          )}

                          {!view && (
                            <NumberInput
                              className={classes.outcomeNumberInput}
                              label={labels?.outcomeNumberLabel}
                              size="sm"
                              variant="filled"
                              value={goal?.goalNumber || index + 1}
                              onChange={(value) => {
                                handleGoalsChange(
                                  goal?.id,
                                  "goalNumber",
                                  value,
                                );
                              }}
                              placeholder="Enter outcome number"
                              error={errors[`goalNumber${index}`]}
                              icon={
                                <ActionIcon
                                  className={classes.inc_dec_Btn}
                                  size="xs"
                                  onClick={() =>
                                    handleGoalsChange(
                                      goal?.id,
                                      "goalNumber",
                                      (goal?.goalNumber || index + 1) - 1,
                                    )
                                  }
                                >
                                  <FaMinus size={15} color="#000" />
                                </ActionIcon>
                              }
                              rightSection={
                                <ActionIcon
                                  className={classes.inc_dec_Btn}
                                  size="xs"
                                  onClick={() =>
                                    handleGoalsChange(
                                      goal?.id,
                                      "goalNumber",
                                      (goal?.goalNumber || index + 1) + 1,
                                    )
                                  }
                                >
                                  <FaPlus size={15} color="#000" />
                                </ActionIcon>
                              }
                            />
                          )}
                          <Grid gutter={24}>
                            <Grid.Col span={12} sm={12}>
                              {view ? (
                                <Box>
                                  <Text
                                    color="#737373"
                                    fz={14}
                                    fw={400}
                                    ff="Inter"
                                  >
                                    Title
                                  </Text>
                                  <Text
                                    color="#262626"
                                    fz={16}
                                    fw={600}
                                    ff="Inter"
                                  >
                                    {goal?.Identified_Relevant_Attainable_Goals}
                                  </Text>
                                </Box>
                              ) : (
                                <TextInput
                                  id="add-care-title"
                                  className={classes.input}
                                  label={labels?.outcomeTitleLabel}
                                  variant="filled"
                                  size="sm"
                                  placeholder={`Enter goal title`}
                                  disabled={view}
                                  value={
                                    goal?.Identified_Relevant_Attainable_Goals
                                  }
                                  onChange={(e) => {
                                    handleGoalsChange(
                                      goal?.id,
                                      "Identified_Relevant_Attainable_Goals",
                                      e?.target?.value,
                                    );
                                  }}
                                  error={
                                    errors[
                                      `Identified_Relevant_Attainable_Goals${index}`
                                    ]
                                  }
                                />
                              )}
                            </Grid.Col>
                            <>
                              <Grid.Col span={12}>
                                <Textarea
                                  id="add-care-note"
                                  autosize={view}
                                  minRows={4}
                                  maxRows={10}
                                  className={classes.textArea}
                                  size="sm"
                                  variant="filled"
                                  label="Target behavior"
                                  placeholder="Enter description"
                                  readOnly={view}
                                  value={goal?.targetBehavior}
                                  onChange={(e) => {
                                    handleGoalsChange(
                                      goal?.id,
                                      "targetBehavior",
                                      e?.target?.value,
                                    );
                                  }}
                                />
                              </Grid.Col>
                            </>

                            <Grid.Col span={12}>
                              <Text
                                variant="text"
                                ff={"Inter"}
                                fw={600}
                                fz={"18px"}
                                color="#000"
                              >
                                {`${labels?.typeTitle} Details`}
                              </Text>
                              {goal.goalActivities?.length > 0 &&
                                goal?.goalActivities?.map((_oa, oaIndex) => (
                                  <Group key={_oa.id} gap={24} mt={24}>
                                    <Box
                                      style={{
                                        width: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "24px",
                                      }}
                                    >
                                      <Box className={classes.activitiesBox}>
                                        <Box
                                          className={classes.activityBoxHeader}
                                        >
                                          <p disabled={view}>
                                            {`${goal?.goalNumber}${alphabet[oaIndex]}` ||
                                              index + 1}
                                          </p>
                                          {goal.goalActivities?.length > 1 &&
                                            !view && (
                                              <ActionIcon
                                                onClick={() =>
                                                  removeGoalActivity(_oa?.id)
                                                }
                                              >
                                                <IoClose
                                                  color="#000"
                                                  size={20}
                                                />
                                              </ActionIcon>
                                            )}
                                        </Box>
                                        <Box className={classes.activityFields}>
                                          {!view &&
                                            edit &&
                                            segment !== "draft" && (
                                              <Flex
                                                align="center"
                                                justify="end"
                                              >
                                                <Switch
                                                  checked={
                                                    openedModal &&
                                                    discontinueType ===
                                                      "goalActivities"
                                                  }
                                                  color="yellow"
                                                  disabled={
                                                    _oa?.isActive === false ||
                                                    goal?.isActive === false
                                                  }
                                                  labelPosition="left"
                                                  label={
                                                    <Text
                                                      fz={18}
                                                      ff={"Inter"}
                                                      color="#262626"
                                                      fw={600}
                                                    >
                                                      Discontinue Activity
                                                    </Text>
                                                  }
                                                  onChange={(event) => {
                                                    if (
                                                      event.currentTarget
                                                        .checked
                                                    ) {
                                                      openCarePlanModal(
                                                        "goalActivities",
                                                        "goalActivities",
                                                      );
                                                      setActivtyId(_oa?.id);
                                                      setOutcomeId(goal?.id);
                                                    }
                                                  }}
                                                />
                                              </Flex>
                                            )}
                                          <Grid gutter={14}>
                                            <Grid.Col span={12} sm={6}>
                                              {/* Support Activity */}
                                              <Textarea
                                                id="add-care-activity"
                                                autosize={view}
                                                className={classes.textArea}
                                                w="100%"
                                                label={
                                                  labels?.supportActivityLabel
                                                }
                                                size="sm"
                                                minRows={4}
                                                maxRows={10}
                                                readOnly={view}
                                                placeholder="Enter Objectives"
                                                value={_oa?.objectives}
                                                onChange={(e) => {
                                                  handleGoalActivityChange(
                                                    goal?.id,
                                                    "objectives",
                                                    e?.target?.value,
                                                    _oa?.id,
                                                  );
                                                }}
                                              />
                                            </Grid.Col>
                                            <Grid.Col span={12} sm={6}>
                                              {/* Support Instruction */}

                                              <Textarea
                                                id="add-care-instruction"
                                                label={
                                                  labels?.supportInstructionsLabel
                                                }
                                                autosize={view}
                                                className={classes.textArea}
                                                w="100%"
                                                size="sm"
                                                minRows={4}
                                                maxRows={10}
                                                placeholder={`Enter ${labels?.supportInstructionsLabel.toLowerCase()}`}
                                                readOnly={view}
                                                value={
                                                  _oa?.Intervention_Instruction
                                                }
                                                onChange={(e) => {
                                                  handleGoalActivityChange(
                                                    goal?.id,
                                                    "Intervention_Instruction",
                                                    e?.target?.value,
                                                    _oa?.id,
                                                  );
                                                }}
                                              />
                                            </Grid.Col>
                                          </Grid>
                                        </Box>
                                      </Box>

                                      {oaIndex ===
                                        goal.goalActivities.length - 1 &&
                                        !view && (
                                          <Button
                                            onClick={() =>
                                              addGoalActivity(
                                                index,
                                                _oa.objectiveNumber
                                                  ? _oa.objectiveNumber
                                                  : "",
                                                oaIndex,
                                              )
                                            }
                                            className={
                                              classes.addNewActivityBtn
                                            }
                                            ref={buttonRef}
                                          >
                                            <IconPlus size={15} />
                                            {labels?.addNewDetailsLabel}
                                          </Button>
                                        )}
                                    </Box>
                                  </Group>
                                ))}
                            </Grid.Col>
                            <Grid.Col span={12}>
                              <Box className={classes.frequencyAndByWhen}>
                                {/* Outcome Frequency */}

                                <TextInput
                                  className={classes.input}
                                  label={"Frequency"}
                                  variant="filled"
                                  size="sm"
                                  style={{
                                    flex: 1,
                                  }}
                                  placeholder="Add Frequency"
                                  value={goal?.goalFrequency}
                                  onChange={(e) => {
                                    handleGoalsChange(
                                      goal?.id,
                                      "goalFrequency",
                                      e?.target?.value,
                                    );
                                  }}
                                  disabled={view}
                                  error={errors[`goalFrequency${index}`]}
                                />

                                <TextInput
                                  className={classes.input}
                                  label={"Duration"}
                                  variant="filled"
                                  size="sm"
                                  style={{
                                    flex: 1,
                                  }}
                                  placeholder="Add Duration"
                                  value={goal?.goalDuration}
                                  onChange={(e) => {
                                    handleGoalsChange(
                                      goal?.id,
                                      "goalDuration",
                                      e?.target?.value,
                                    );
                                  }}
                                  disabled={view}
                                  error={errors[`goalDuration${index}`]}
                                />
                                <TextInput
                                  className={classes.input}
                                  label={"Timeframe"}
                                  variant="filled"
                                  size="sm"
                                  style={{
                                    flex: 1,
                                  }}
                                  placeholder="Add Timeframe"
                                  value={goal?.goalTimeframe}
                                  onChange={(e) => {
                                    handleGoalsChange(
                                      goal?.id,
                                      "goalTimeframe",
                                      e?.target?.value,
                                    );
                                  }}
                                  disabled={view}
                                  error={errors[`goalTimeframe${index}`]}
                                />
                              </Box>
                            </Grid.Col>
                          </Grid>

                          {/* Outcome Category */}
                          {showCustomOutcome[goal?.id] && (
                            <SimpleGrid
                              cols={isMobileScreen ? 1 : 2}
                              className={classes.supportPlaneTopSection}
                            >
                              <Textarea
                                autosize={view}
                                className={classes.textArea}
                                style={{ marginTop: "15px" }}
                                label="Add Custom Outcome"
                                size="sm"
                                placeholder="Enter outcome"
                                disabled={view}
                                value={goal?.customOutcome}
                                onChange={(e) => {
                                  handleGoalsChange(
                                    goal?.id,
                                    "customOutcome",
                                    e?.target?.value,
                                  );
                                }}
                              />
                            </SimpleGrid>
                          )}

                          {/* Individual needs, strengths, abilities, personal preferences */}
                          <SimpleGrid
                            cols={isMobileScreen ? 1 : 1}
                            className={classes.mwd}
                          >
                            <>
                              <Textarea
                                id="add-care-reason"
                                autosize={view}
                                label={
                                  "Individual needs, strengths, abilities, personal preferences"
                                }
                                minRows={4}
                                maxRows={10}
                                className={classes.textArea}
                                size="sm"
                                placeholder="Enter response"
                                readOnly={view}
                                value={goal?.goalNote}
                                onChange={(e) => {
                                  handleGoalsChange(
                                    goal?.id,
                                    "goalNote",
                                    e?.target?.value,
                                  );
                                }}
                              />
                            </>
                          </SimpleGrid>
                        </form>
                      </Accordion.Panel>
                    </Accordion.Item>
                  ))}
                </Accordion>
              ) : (
                <NoRecord />
              )}
              {!view && (
                <Box className={classes.addAndSaveBtnParent}>
                  <Button onClick={addGoals} className="addBtn">
                    {`Add New ${labels?.addNewButtonLabel}`}
                  </Button>
                  {((selectedPlanType === 3 &&
                    essentialSupportAdded === "no") ||
                    selectedPlanType !== 3) && (
                    <SaveButton
                      loading={addPlanLoading}
                      onClick={onSave}
                      disabled={view}
                      isGoalsSaveButton={true}
                      isEdit={edit}
                    />
                  )}
                </Box>
              )}
            </Box>
          </>
        )}

        {/* ===== NEW SERVICE PLAN COMPONENT ===== */}
        {selectedPlanType === 5 && (
          <ServicePlanForm
            view={view}
            edit={edit}
            rowData={rowData}
            onSave={async (servicePlanData) => {
              // Update outcome state with service plan data
              // This will be picked up by the main onSave function
              // setOutcome(servicePlanData);
              await onSave(false,servicePlanData);
            }}
            onClose={closeCarePlanModal}
            client={clientDetails}
            selectedFacility={selectedFacility}
            addPlanLoading={addPlanLoading}
            headerInputSection={renderHeaderInputs()}
            period={state}
            planTypeId={selected}
            carePlanType={carePlanType}
            openAddMedicalModal={openAddMedicalModal}
            closeCarePlanModal={servicePlanDrawerClose}
            errors={errors}
            setErrors={setErrors}
            initialOutcome={initialOutcome}
            initialEssentialSupport={initialEssentialSupport}
            initialGoals={initialGoals}
          />
        )}
      </Drawer>
      <DiscontinueCarePlanModal
        discontinueType={discontinueType}
        outcomes={outcomeData}
        opened={!!openedModal}
        onclose={closeModal}
        client={client}
        contentType={openedModal}
        id={rowData?._id}
        segment={segment}
        // currentPage={currentPage}
        setShowCarePlanDetails={setShowCarePlanDetails}
        setRowData={setRowData}
        activityId={activityId}
        outcomeId={outcomeId}
      />
    </>
  );
}

const SaveButton = ({
  loading,
  disabled,
  onClick,
  className,
  isEdit,
  isGoalsSaveButton = false,
}) => {
  const [opened, { open, close }] = useDisclosure(false);

  const handleClick = () => {
    if (isGoalsSaveButton && isEdit) {
      open(); // Open modal for goals
    } else {
      onClick(); // Directly call onClick for non-goals
    }
  };

  const handleSave = () => {
    onClick(true); // Execute the save function
    close(); // Close the modal
  };

  return (
    <>
      <Button
        id="add-care-save"
        loading={loading}
        onClick={handleClick}
        disabled={disabled}
        className={`saveBtn ${className ? className : ""}`}
      >
        Save
      </Button>

      {/* Modal for goals save confirmation */}
      <Modal
        opened={opened}
        onClose={close}
        title="Confirm Save"
        centered
        zIndex={2000}
        overlayProps={{ opacity: 0.5, blur: 3 }}
      >
        <Text ff={"Inter, sans-serif"} size="sm" ta={"center"}>
          Are you sure you want to save these goals?
        </Text>

        <Group position="center" mt="md">
          <Button
            variant="outline"
            onClick={() => onClick(false)}
            color="yellow"
            radius={"md"}
          >
            Save
          </Button>
          <Button onClick={handleSave} color="yellow" radius={"md"}>
            New Save
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default CarePlanDetailsDrawer;
